import {d3} from "d3";
import Datastorage from "datastorage";
import EventBus from "./utils/EventBus.js";

import Application from "./Application.js";
import Test from "./Test.js";

import log from "loglevel";

const global = {
    d3,
    event_bus: new EventBus("f_mtac"),
    log,
    revision: {version: __app_version__, patch: __app_patch__}
};
console.log("Agnet Tacteam Starting...");
global.app = new Application(global);
global.test = new Test(global);
global.datastorage = new Datastorage();

export default global;
